const ASSESSOR_APPROVE = 'dofe-bo/advjouEvents/ASSESSOR_APPROVE'
const ASSESSOR_APPROVE_SUCCESS = 'dofe-bo/advjouEvents/ASSESSOR_APPROVE_SUCCESS'
const ASSESSOR_APPROVE_FAIL = 'dofe-bo/advjouEvents/ASSESSOR_APPROVE_FAIL'

const initialState = {
  detail: {}
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ASSESSOR_APPROVE:
      return {
        ...state,
        loading: true
      }
    case ASSESSOR_APPROVE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case ASSESSOR_APPROVE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function assessorApprove() {
  return {
    types: [ASSESSOR_APPROVE, ASSESSOR_APPROVE_SUCCESS, ASSESSOR_APPROVE_FAIL],
    promise: client => client.post('api/assessor/approve')
  }
}
